import React, { memo, ReactNode } from "react";
import "./index.less";
const ChatLayoutContainerCom: React.FC<{ children: ReactNode }> = ({ children }) => {
    return <div className="chat-friend-layout-container">{children}</div>;
};

export const ChatLayoutContainer = memo(ChatLayoutContainerCom);
